import { BANDS_TAB_ID, BILLING_TAB_ID, MAIN_NAVIGATION_TAB_IDS } from './MainNavigationTabSpecs';
import {
  ACTIVE_TAB_STORAGE_KEY as ACTIVE_TAB_STORAGE_KEY_VALUE,
  NAVIGATE_TAB_EVENT as NAVIGATE_TAB_EVENT_VALUE,
} from './navigationEvents';

export const TAB_IDS = MAIN_NAVIGATION_TAB_IDS;
export const ACTIVE_TAB_STORAGE_KEY = ACTIVE_TAB_STORAGE_KEY_VALUE;
export const NAVIGATE_TAB_EVENT = NAVIGATE_TAB_EVENT_VALUE;
export { BANDS_TAB_ID, BILLING_TAB_ID };
